<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-1">
      <h1 class="mat-h1">Ask Geo</h1>
    </div>
    <div class="col-md-6">
      <form class="search-section">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            placeholder="Search"
            class="search-text"
            [(ngModel)]="searchKeyWord"
            [ngModelOptions]="{ standalone: true }"
            maxlength="150"
            (keypress)="onKeySearchPress($event)"
            tabindex="1"
            autofocus
            />
            <mat-icon class="cursor search" matSuffix (click)="onKeySearchButtonPress($event)">search</mat-icon>
          </mat-form-field>
        </form>
      </div>
      <div class="col-md-1">
        <button class ="summary"
          mat-icon-button
          matTooltip="Show generated summary"
          (click)="showGeneratedSummary = !showGeneratedSummary"
          [hidden]="!generatedSummary">
          <mat-icon>
            {{ showGeneratedSummary ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </div>
    </div>

    @if (showGeneratedSummary && generatedSummary) {
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="query-summary">
            <pre class="query-box">{{ generatedSummary }}</pre>
            <pre class="query-box">QUERY : {{ generatedQuery }}</pre>
          </div>
        </div>
      </div>
    }

    @if (errorMessage) {
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    }

    @if (!errorMessage && dataSource.data.length > 0) {
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>
              @for (column of displayedColumns; track column) {
                <ng-container [matColumnDef]="column">
                  <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                  <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
      </div>
    }
  </div>
